import React from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

type ErrorDialogProps = {
  open: boolean;
  message: string;
  onClose: () => void;
};

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, message, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          overflow: 'visible',
          boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            backgroundColor: '#d32f2f',
            borderRadius: '12px',
            padding: '24px 28px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
            position: 'relative',
          }}
        >
          <ErrorOutlineIcon sx={{ color: '#fff', fontSize: '32px', mt: '2px', flexShrink: 0 }} />
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '1rem', mb: 0.5 }}>
              Error
            </Typography>
            <Typography sx={{ color: '#fff', fontSize: '0.95rem', lineHeight: 1.6 }}>
              {message}
            </Typography>
          </Box>
          <IconButton
            size="small"
            aria-label="close"
            onClick={onClose}
            sx={{
              color: '#fff',
              position: 'absolute',
              top: '10px',
              right: '10px',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
